<template>
  <template v-if="modelValue">
    <h4 class="text-base mt-4 mb-8">
      {{ wt('organisation', 'planningSideOptions', 'title') }}
    </h4>
    <section class="boxed-button-grid mb-12">
      <label
        v-for="option in PlanningSideOptions"
        :key="option"
        class="base-button"
        v-tooltip="getPlanningSideTooltip(option)"
        :class="{
          active: modelValue?.planningSideOption === option,
          disabled: option === 'GENERAL_PLANNER' && isGeneralPlannerDisabled,
          'base-button--tooltip-enabled': !!getPlanningSideTooltip(option),
          'cursor-help': !!getPlanningSideTooltip(option),
        }"
        >{{ wt('organisation', 'planningSideOptions', 'option', option) }}
        <input
          type="radio"
          :value="option"
          v-model="modelValue.planningSideOption"
          :id="option"
          name="planningSideOption"
          :disabled="option === 'GENERAL_PLANNER' && isGeneralPlannerDisabled" />
      </label>
    </section>
    <h4 class="text-base mb-8">
      {{ wt('organisation', 'companySideOptions', 'title') }}
    </h4>
    <section class="boxed-button-grid mb-12">
      <label
        v-for="option in CompanySideOptions"
        :key="option"
        class="base-button"
        :class="{
          active: modelValue?.companySideOption === option,
        }"
        >{{ wt('organisation', 'companySideOptions', 'option', option) }}
        <input
          type="radio"
          :value="option"
          v-model="modelValue.companySideOption"
          :id="option"
          name="companySideOption" />
      </label>
    </section>
  </template>
</template>

<script lang="ts" setup>
import { CompanySideOptions, PlanningSideOptions } from '@/schemas/general/enums'
import { computed, type PropType } from 'vue'
import { useWidgetText } from '@/helpers/useWidgetText'

const { wt } = useWidgetText('widget-texts-project-general')

interface ProjectOrganisationForm {
  planningSideOption: PlanningSideOptions
  companySideOption: CompanySideOptions
}

const modelValue = defineModel({ type: Object as PropType<ProjectOrganisationForm> })

const isGeneralPlannerDisabled = computed(() => true)
const planningSideTooltipTheme = { 'max-width': '350px' } as const

function getPlanningSideTooltip(
  option: PlanningSideOptions
): string | { text: string; theme: typeof planningSideTooltipTheme } {
  if (option !== 'GENERAL_PLANNER' || !isGeneralPlannerDisabled.value) {
    return ''
  }

  const text = wt('organisation', 'planningSideOptions', 'tooltip', option)
  if (!text) {
    return ''
  }

  return {
    text,
    theme: planningSideTooltipTheme,
  }
}
</script>
